import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect, useRef } from "react";
import "./BarcodeReader.css";
import Axios from "axios";
import swal from "sweetalert";
import Table from "react-bootstrap/Table";

import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.min.css";

const ScanInbound = () => {
  const [checkboxClickCount, setCheckboxClickCount] = useState(0);
  const [barcode, setBarcode] = useState("");
  const [barcodeData, setBarcodeData] = useState([]);
  const [selectedRow, setSelectedRow] = useState();
  const [selectedRowBarcodeData, setSelectedRowBarcodeData] = useState();
  const [count, setCount] = useState(0);
  const [data1, setdata] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const barcodeInputRef = useRef(null);
  const [, setshelfdata] = useState([]);
  const [selectedRowShelfData, setSelectedRowShelfData] = useState([]);
  const [selectedShelfId, setSelectedShelfId] = useState(null);
  const [barcodeSet, setBarcodeSet] = useState(new Set());

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/api/creategrn/getgrn`).then(
      (response) => {
        setdata(response.data);
      }
    );
  }, []);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getManageshelf`).then(
      (response) => {
        setshelfdata(response.data);

        const newBarcodeSet = new Set();
        response.data.forEach((item) => {
          if (item.barcodeData) {
            item.barcodeData.forEach((barcodeValue) =>
              newBarcodeSet.add(barcodeValue)
            );
          }
        });
        setBarcodeSet(newBarcodeSet);
      }
    );
  }, []);

  useEffect(() => {
    if (checkboxClickCount >= 2) {
      window.location.reload();
    }
  }, [checkboxClickCount]);

  const handleCheckboxChange = async (row) => {
    setSelectedRow(row);
    setCheckboxClickCount(checkboxClickCount + 1);

    try {
      const response = await Axios.get(
        `${INVENTORY_API_BASE_URL}/getManageshelf`
      );

      setSelectedRowShelfData(response.data);
    } catch (error) {
      console.error("Error fetching shelf data:", error);
    }
  };

  const handleCheckboxChangeShelf = (shelfId) => {
    if (selectedShelfId === shelfId) {
      setSelectedShelfId(null);
    } else {
      setSelectedShelfId(shelfId);
    }
  };

  const AddBarcode = () => {
    const isBarcodeMatched = barcodeSet.has(barcode);
    if (selectedRow) {
      const Sku = selectedRow.sku;

      if (barcode.includes(Sku) && !isBarcodeMatched) {
        if (!barcodeData.includes(barcode)) {
          setBarcodeData((prevData) => [...prevData, barcode]);
          setCount((prevCount) => prevCount + 1);
          if (
            selectedRowBarcodeData &&
            selectedRow.index in selectedRowBarcodeData
          ) {
            setSelectedRowBarcodeData((prevSelectedRowBarcodeData) => ({
              ...prevSelectedRowBarcodeData,
              [selectedRow.index]: {
                barcode,
                count,
              },
            }));
          } else {
            setSelectedRowBarcodeData((prevSelectedRowBarcodeData) => ({
              ...prevSelectedRowBarcodeData,
              [selectedRow.index]: {
                barcode,
                count: 1,
              },
            }));
          }
          alertify.success("Barcode scanned successfully", 3);
        } else {
          alertify.error("Barcode already scanned", 3);
        }
      } else {
        alertify.error("Invalid or Barcode Already Present in Shelf", 3);
      }
    }
  };


  const handleManualBarcodeEntry = () => {
    if (!selectedRow) {
      alertify.alert("Please select a row");

      return;
    }

    if (!selectedShelfId) {
      alertify.alert("Please Check the Shelf");

      return;
    }
    if (barcode.trim() !== "") {
      AddBarcode();

      setBarcode("");
      barcodeInputRef.current.focus();
    }
  };

  useEffect(() => {
    if (data1) {
      const filtered = data1.filter((row1) => {
        if (row1.orderno) {
          return row1.orderno.includes(searchQuery);
        }
        return false;
      });
      setFilteredData(filtered);
    }
  }, [data1, searchQuery]);

  useEffect(() => {
    const handleBarcodeScan = (event) => {
      if (event.key === "Enter") {
        if (!selectedShelfId) {
          alertify.alert("Warning", "Please Check the Shelf");

          return;
        }
        AddBarcode();

        setBarcode("");
      }
    };

    const handleDocumentClick = (event) => {
      const clickedElement = event.target;
      if (
        clickedElement !== barcodeInputRef.current &&
        clickedElement.className !== "inboundsearch" &&
        !clickedElement.closest("button")
      ) {
        barcodeInputRef.current.focus();
      }
    };

    window.addEventListener("keydown", handleBarcodeScan);
    document.addEventListener("click", handleDocumentClick);

    return () => {
      window.removeEventListener("keydown", handleBarcodeScan);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [barcode, selectedShelfId]);

  function handleSubmit() {
    if (barcodeData.length === 0) {
      alertify.alert("Warning", "No barcodes have been scanned");

      return;
    }

    const orderNumber = selectedRow.orderno;
    const BatcId = selectedRow.batchid;
    const selectedRowData = selectedRowBarcodeData[selectedRow.index];
    const Titl = selectedRow.title;

    if (!selectedRowData) {
      alertify.alert("No barcode scanned for the selected row");
      return;
    }

    const dataToSend = {
      orderno: orderNumber,
      barcodeData,
      count,
      BatchID: BatcId,
      Title: Titl,
    };

    swal({
      title: "Confirm Inbound",
      text: "Are you sure you want to submit the scanned data?",
      icon: "warning",
      buttons: ["Cancel", "OK"],
    }).then(async (confirmed) => {
      if (confirmed) {
        const selectedShelf = selectedRowShelfData.find(
          (shelf) => shelf._id === selectedShelfId
        );

        if (selectedShelf) {
          const { presentquantity, emptyspace, _id } = selectedShelf;
          const updatedBooksAvailable = presentquantity + count;
          const updatedEmptySpace = emptyspace - count;

          try {
            await Axios.put(`${INVENTORY_API_BASE_URL}/putaway`, {
              id: _id,
              presentquantity: updatedBooksAvailable,
              emptyspace: updatedEmptySpace,
              barcodeData,
            });

            await Axios.post(
              `${INVENTORY_API_BASE_URL}/scanInbound`,
              dataToSend
            );

            swal({
              title: "Putaway Created",
              text: "",
              icon: "success",
            });

            window.location.reload();
          } catch (error) {
            alertify.alert("Service error");
            console.error(error);
          }
        }
      }
    });
  }

  return (
    <main className="scan-inbound-page">
      <div className="scan-inbound-page__inner">
        <header className="scan-inbound-hero">
          <div>
            <p className="scan-inbound-eyebrow"><span aria-hidden="true" /> WAREHOUSE OPERATIONS / INBOUND</p>
            <h1>Scan inbound</h1>
            <p>Receive a GRN into the correct shelf by scanning each book barcode.</p>
          </div>
          <div className={selectedShelfId ? "scan-inbound-status scan-inbound-status--ready" : "scan-inbound-status"}>
            <span aria-hidden="true" />
            {selectedShelfId ? "Shelf selected" : "Select a shelf to begin"}
          </div>
        </header>

        <section className="scan-inbound-panel" aria-labelledby="scan-inbound-batches-title">
          <div className="scan-inbound-panel__header">
            <div className="scan-inbound-section-title">
              <span className="scan-inbound-step" aria-hidden="true">01</span>
              <div>
                <h2 id="scan-inbound-batches-title">Select an inbound batch</h2>
                <p>Choose the order you are receiving before scanning its books.</p>
              </div>
            </div>
            <label className="scan-inbound-search">
              <span className="scan-inbound-search__icon" aria-hidden="true" />
              <input
                className="inboundsearch"
                type="search"
                placeholder="Search order number"
                aria-label="Search by order number"
                value={searchQuery}
                onChange={(event) => setSearchQuery(event.target.value)}
                onKeyDown={(event) => event.stopPropagation()}
              />
            </label>
          </div>

          <div className="scan-inbound-table-wrap">
            <Table className="scan-inbound-table scan-inbound-table--batches" aria-label="Inbound batches">
              <thead>
                <tr>
                  <th scope="col">Select</th>
                  <th scope="col">Order number</th>
                  <th scope="col">Batch ID</th>
                  <th scope="col">Title</th>
                  <th scope="col">Medium</th>
                  <th scope="col">Qty received</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length === 0 ? (
                  <tr>
                    <td className="scan-inbound-empty-cell" colSpan={6}>
                      No inbound batches match this search.
                    </td>
                  </tr>
                ) : (
                  filteredData.map((row2) => (
                    <tr
                      key={row2.index}
                      className={selectedRow?.batchid === row2.batchid ? "is-selected" : ""}
                    >
                      <td data-label="Select">
                        <input
                          type="checkbox"
                          aria-label="Select inbound batch"
                          checked={selectedRow?.batchid === row2.batchid}
                          onChange={() => handleCheckboxChange(row2)}
                        />
                      </td>
                      <td data-label="Order number" className="scan-inbound-order">
                        {row2.orderno}
                      </td>
                      <td data-label="Batch ID">{row2.batchid}</td>
                      <td data-label="Title" className="scan-inbound-title" title={row2.title}>
                        {row2.title}
                      </td>
                      <td data-label="Medium">{row2.Medium}</td>
                      <td data-label="Qty received">
                        <span className="scan-inbound-quantity">{row2.challanquantity}</span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </section>

        {selectedRow && (
          <section className="scan-inbound-panel" aria-labelledby="scan-inbound-shelf-title">
            <div className="scan-inbound-panel__header">
              <div className="scan-inbound-section-title">
                <span className="scan-inbound-step scan-inbound-step--green" aria-hidden="true">02</span>
                <div>
                  <h2 id="scan-inbound-shelf-title">Choose a destination shelf</h2>
                  <p>
                    Batch <strong>{selectedRow.batchid}</strong>
                    <span className="scan-inbound-context-divider">·</span>
                    SKU <strong>{selectedRow.sku}</strong>
                  </p>
                </div>
              </div>
            </div>

            <div className="scan-inbound-table-wrap">
              <Table className="scan-inbound-table scan-inbound-table--shelves" aria-label="Available destination shelves">
                <thead>
                  <tr>
                    <th scope="col">Select</th>
                    <th scope="col">Rack</th>
                    <th scope="col">Shelf</th>
                    <th scope="col">Type</th>
                    <th scope="col">Capacity</th>
                    <th scope="col">Added qty</th>
                    <th scope="col">Empty space</th>
                    <th scope="col">Current qty</th>
                    <th scope="col">After scan</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedRowShelfData.filter((item) => item.sku === selectedRow.sku).length === 0 ? (
                    <tr>
                      <td className="scan-inbound-empty-cell" colSpan={9}>
                        No shelf locations are available for this SKU.
                      </td>
                    </tr>
                  ) : (
                    selectedRowShelfData
                      .filter((item) => item.sku === selectedRow.sku)
                      .map((item) => {
                        const updatedBooksAvailable =
                          selectedShelfId === item._id
                            ? item.presentquantity + count
                            : item.presentquantity;
                        const updatedEmptySpace =
                          selectedShelfId === item._id
                            ? item.emptyspace - count
                            : item.emptyspace;
                        return (
                          <tr
                            key={item._id || item.id}
                            className={selectedShelfId === item._id ? "is-selected" : ""}
                          >
                            <td data-label="Select">
                              <input
                                type="checkbox"
                                aria-label="Select destination shelf"
                                checked={selectedShelfId === item._id}
                                onChange={() => handleCheckboxChangeShelf(item._id)}
                              />
                            </td>
                            <td data-label="Rack">{item.rackno}</td>
                            <td data-label="Shelf" className="scan-inbound-order">{item.shelfno}</td>
                            <td data-label="Type">{item.type}</td>
                            <td data-label="Capacity">{item.capacity}</td>
                            <td data-label="Added quantity">{count}</td>
                            <td data-label="Empty space">{updatedEmptySpace}</td>
                            <td data-label="Current quantity">{item.presentquantity}</td>
                            <td data-label="After scan">
                              <span className="scan-inbound-quantity scan-inbound-quantity--new">
                                {updatedBooksAvailable}
                              </span>
                            </td>
                          </tr>
                        );
                      })
                  )}
                </tbody>
              </Table>
            </div>
          </section>
        )}

        <section className="scan-inbound-panel scan-inbound-scan-panel" aria-labelledby="scan-inbound-scan-title">
          <div className="scan-inbound-panel__header">
            <div className="scan-inbound-section-title">
              <span className="scan-inbound-step scan-inbound-step--dark" aria-hidden="true">03</span>
              <div>
                <h2 id="scan-inbound-scan-title">Scan book barcodes</h2>
                <p>Keep the barcode field focused, or enter a code manually.</p>
              </div>
            </div>
            <div className="scan-inbound-scan-count" aria-live="polite">
              <strong>{count.toLocaleString()}</strong>
              <span>scanned</span>
            </div>
          </div>

          <div className="scan-inbound-scan-grid">
            <div className="scan-inbound-entry">
              <label htmlFor="scan-inbound-barcode">Barcode scanner or manual entry</label>
              <input
                id="scan-inbound-barcode"
                className="scan-inbound-barcode"
                type="text"
                ref={barcodeInputRef}
                value={barcode}
                placeholder="Scan a barcode or type it here"
                autoComplete="off"
                onChange={(event) => setBarcode(event.target.value)}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    event.preventDefault();
                  }
                }}
              />
              <p>Scanned codes are checked against the selected SKU and existing shelf inventory.</p>
              <div className="scan-inbound-manual">
                <span>Entered a code manually?</span>
                <button
                  className="scan-inbound-button scan-inbound-button--secondary"
                  type="button"
                  onClick={handleManualBarcodeEntry}
                >
                  Add manually
                </button>
              </div>
            </div>

            <div className="scan-inbound-results">
              <div className="scan-inbound-results__heading">
                <h3>Scanned barcodes</h3>
                <span>{barcodeData.length.toLocaleString()}</span>
              </div>
              {barcodeData.length === 0 ? (
                <div className="scan-inbound-results__empty">
                  Scanned barcodes will appear here.
                </div>
              ) : (
                <ul className="scan-inbound-barcode-list">
                  {barcodeData.map((barcodeValue, index) => (
                    <li key={index}>
                      <span>{barcodeValue}</span>
                      <span className="scan-inbound-barcode-list__check" aria-hidden="true">✓</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          <div className="scan-inbound-save-row">
            <p>Confirm the batch, destination shelf, and scanned count before saving.</p>
            <button className="scan-inbound-button scan-inbound-button--primary" type="button" onClick={handleSubmit}>
              Save scanned ID
            </button>
          </div>
        </section>
      </div>
    </main>
  );
};

export default ScanInbound;
